<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <camera-schedule-sidebar :isCameraScheduleSidebarActive="addNewScheduleDataSidebar" @closeSidebar="toggleCamraScheduleDataSidebar" :data="cameraScheduleSidebarData" />
    <camera-setting-sidebar :isCameraSettingSidebarActive="addNewSettingDataSidebar" @closeSidebar="toggleCamraSettingDataSidebar" :data="cameraSettingSidebarData" />
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @closeSidebar="toggleScheduleSidebar" :data="scheduleData" />

    <!-- ADD NEW -->
     <vs-popup fullscreen title="" :active.sync="popupActive">
    <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset" allowfullscreen></iframe>
  </div>
      </vs-popup>
    <div>
    <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Camera</vs-button>
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    </div>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search :data="filteredCameraList">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="selected.length>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
           <vx-tooltip text="Search By Location" position="top" v-if="locln>1">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">{{ $t('student.filters.search_by_location') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location')">
                <span class="flex items-center">
                  <span  >ALL</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span >{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>


          <!-- ADD NEW -->
<!--          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">-->
<!--              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />-->
<!--              <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ cameras.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : cameras.length }} of {{ queriedcameras }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">

        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="location">Location</vs-th>
         <!-- <vs-th sort-key="status">Status</vs-th> -->
        <vs-th sort-key="location">Camera ID</vs-th>
        <vs-th sort-key="color_code">Color</vs-th>

        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.code }}</p>
              </vs-td>
              <vs-td>
                <vs-chip>{{tr.location.name}}</vs-chip>
              </vs-td>
              <!-- <vs-td>
                  <vs-switch v-model="tr.status"></vs-switch>
              </vs-td> -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.camera_id }}</p>
              </vs-td>
              <vs-td>
                <ul>
                  <span @click="PalyCamera" ><li  :style="{background: tr.color_code}" class="w-4 h-4 round" /></span>
                </ul>
              </vs-td>
                <vs-td class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                    </vs-dropdown-item>
                     <vs-dropdown-item  @click="cameraSettingData(tr)">
                <span class="flex items-center">
                  <feather-icon icon="SettingsIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Settings</span>
                </span>
                </vs-dropdown-item>
<!--                <vs-dropdown-item>-->
<!--                <span class="flex items-center" @click="addSchedule(tr)">-->
<!--                  <feather-icon icon="CalendarIcon"  svgClasses="h-4 w-4" class="mr-2"/>-->
<!--                  <span>Schedule</span>-->
<!--                </span>-->
<!--                </vs-dropdown-item>-->
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './addSidebarView.vue'
import CameraSettingSidebar from './cameraSetttingSidebarView.vue'
import CameraScheduleSidebar from './addScheduleSidebar.vue'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import {ALL_CAMERAS, ALL_LOCATIONS} from '@/graphql'
import {REMOVE_CAMERA, PLAY_CAMERA} from '@/graphql'


export default {
  components: {
    DataViewSidebar,
    CameraSettingSidebar,
    CameraScheduleSidebar,
    ScheduleViewSidebar

  },
  data () {
    return {
      cameras:[],
      locations:[],
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      popupActive: false,
      IframeSrc:'',
      custom_search_filter:'Search By Location',


      // Data Sidebar
      addNewDataSidebar: false,
      addNewSettingDataSidebar: false,
      addNewScheduleDataSidebar: false,
      sidebarData: {},
      cameraSettingSidebarData: {},
      cameraScheduleSidebarData: {},
      addScheduleSidebar:false,
      scheduleData:{},
      DeletedItem:''
    }
  },
  computed: {
    filteredCameraList () {
      const custom_search_filter = this.custom_search_filter
      return this.cameras.filter(function (camera) {
        if (custom_search_filter == 'Search By Location') {
          return true
        }
        if (custom_search_filter !== 'Search By Location') {
          return camera.location.name.match(custom_search_filter)
        }
        return true
      })

    },
    reset () {
      if (this.popupActive) {
        return this.IframeSrc
      }
      if (!this.popupActive) {
        
      }
    },
    locln () {
      return this.locations.length
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    // cameras () {
    //   return this.$store.state.dataList.cameras
    // },
    queriedcameras () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.cameras.length
    }

  },
  methods: {
    setSelected (value) {
      this.custom_search_filter = value
    },
    PalyCamera () {
      this.$apollo
        .mutate({
          mutation: PLAY_CAMERA,
          variables: {
            id:'0'
          }
        })
        .then(response => {
          if (response) {
            this.IframeSrc = response.data.playCamera.embed_code
            this.popupActive = true
          }
        }).catch(error => {
          console.log(error)
        })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Camera',
        text: status,
        color,
        position: 'top-right'
      })
    },
    confirmDeleteRecord (camera) {
      this.DeletedItem = camera
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${camera.name} "`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_CAMERA,
          variables: {
            id:  this.DeletedItem.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteCamera.state == 'Success') {
            this.StatusSuccess(response.data.deleteCamera.message, response.data.deleteCamera.color)
          } else {
            this.StatusSuccess(response.data.deleteCamera.message, response.data.deleteCamera.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    cameraSettingData (data) {
      this.cameraSettingSidebarData = data
      this.toggleCamraSettingDataSidebar(true)
    },
    cameraScheduleData (data) {
      this.cameraScheduleSidebarData = data
      this.toggleCamraScheduleDataSidebar(true)
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    toggleCamraScheduleDataSidebar (val = false) {
      this.addNewScheduleDataSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleCamraSettingDataSidebar (val = false) {
      this.addNewSettingDataSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleCamUserSidebar (val = false) {
      this.addNewCamUserSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
      if (!val) {
        this.get()
      }
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_CAMERAS
        })
        .then(response => {
          this.cameras = response.data.cameras
        })
      this.$apollo
        .mutate({
          mutation: ALL_LOCATIONS
        })
        .then(response => {
          this.locations = response.data.locations
        })
    }
  },
  created () {
    this.get()

  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
